/**
 * Modal Controller
 *
 * Manages HTML <dialog> elements for modal dialogs.
 * Tracks modal open/close events via breadcrumbs for debugging.
 *
 * Breadcrumbs:
 *   - UI/modal_open: When modal is shown
 *   - UI/modal_close: When modal is closed
 *
 * Metadata: modalId, ariaLabel (on open)
 *
 * @extends ApplicationController
 */

import ApplicationController from '../../javascript/controllers/application_controller'

export default class extends ApplicationController {
  connect() {
    this.open()
    this.element.addEventListener('close', this.handleClose)
  }

  disconnect() {
    this.close()
    this.element.removeEventListener('close', this.handleClose)
  }

  open() {
    // Add breadcrumb when modal opens (central method for all open paths)
    this.addBreadcrumb('UI', 'modal_open', {
      modalId: this.element.id || 'unknown',
      ariaLabel: this.element.getAttribute('aria-labelledby'),
    })

    this.element.showModal()
    this.element.setAttribute('aria-hidden', 'false')
  }

  close() {
    this.element.close()
  }

  handleClose = () => {
    // Add breadcrumb BEFORE closing
    this.addBreadcrumb('UI', 'modal_close', {
      modalId: this.element.id || 'unknown',
    })

    this.removeSrcFromNextTurboFrame()
    this.element.setAttribute('aria-hidden', 'true')
    // Self-destruct after closing, to better support jumping in history back and forth
    this.element.remove()
  }

  removeSrcFromNextTurboFrame() {
    let currentElement = this.element

    while ((currentElement = currentElement.parentNode)) {
      if (currentElement.tagName === 'TURBO-FRAME') {
        currentElement.removeAttribute('src')
        return
      }
    }
  }
}
